import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore"

const config = {
    apiKey: "AIzaSyD4pfCExrP2jhurv5J544dFFl7UpoPDGVk",
    authDomain: "safejourneyerie.firebaseapp.com",
    databaseURL: "https://safejourneyerie.firebaseio.com",
    projectId: "safejourneyerie",
    storageBucket: "safejourneyerie.appspot.com",
    messagingSenderId: "456027895138",
    appId: "1:456027895138:web:fd49e6dd1375a4a3b5a83b",
    measurementId: "G-59TJ3HE8E6"
}

// Initialize app with the config vars
firebase.initializeApp(config)

// Initialize DB
const db = firebase.firestore()

export { db }

export default firebase